import { Component } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-express-curiosity",
  templateUrl: "./express-curiosity.component.html",
  styleUrls: ["./express-curiosity.component.scss"],
})
export class ExpressCuriosityComponent {
  curiosity = [
    {
      name: "connectLegends",
      heading1: "Learn From ",
      heading2: " Our Gurus ",
      image: environment.assUrl + "assets/images/homepage/CWL.png",
      details:
        "We bring legendary artists and experts in your chosen performing arts genre to guide and inspire you. Learn directly from the masters, and let their wisdom enrich your artistic journey. Connect, learn, and soar with Virsa.",
    },
    {
      name: "doorsteps",
      heading1: "Learn at Your ",
      heading2: " Doorstep",
      image: environment.assUrl + "assets/images/homepage/TAYD.png",
      details:
        "We bring expert instructors directly to your location, removing the overhead of travel and providing convenience like never before. Embrace the ease of learning with Virsa as we make mastering the performing arts accessible and hassle-free.",
    },
    {
      name: "professionalTrainer",
      heading1: "Join us as a ",
      heading2: " Professional Trainer",
      image: environment.assUrl + "assets/images/homepage/BPT.png",
      details:
        "invites skilled instructors to impart their wisdom and contribute to youth building. Empower the next generation with your expertise and become part of our mission to nurture talent and shape the future. Join us in making a difference through the performing arts.",
    },
  ];
}
